'use client'

import { useEffect } from 'react'

import { useApolloClient } from '@apollo/client'

import { useGlobalLoading } from 'src/hooks/useGlobalLoading'

export function AutoHideInitialGlobalLoading() {
  const { hideGlobalLoading, isAutoInitialHideEnabled } = useGlobalLoading()

  const client = useApolloClient()
  const activeQueries = client.getObservableQueries()
  const isLoading = [...activeQueries.values()].some(query => query.getCurrentResult().loading)

  useEffect(() => {
    // 初回ローディングの自動非表示が有効、かつapolloを使ったqueryの読み込みが完了した場合true
    if (isAutoInitialHideEnabled && !isLoading) {
      // 1秒後にローディングを非表示にする（1秒待つことで自然に消えるようにする）
      const timer = setTimeout(() => hideGlobalLoading(), 1000)
      return () => clearTimeout(timer)
    }
  }, [client, hideGlobalLoading, isAutoInitialHideEnabled, isLoading])

  return null
}
